import React, { useState } from 'react';
// 加载、无数据情况开发参考经分内容，通用视觉规范相同
// import Abnormal from '@/pages/dashboard/components/Abnormal';

import GameRow from './GameRow';
import { connect } from 'umi';

const GameList = (props: any) => {
  const {
    list = [],
    searchValue,
    gameInfo,
    isCollect, // 是否有收藏按钮
    handleCollect,
    searchText,
  } = props;

  return (
    <>
      {list?.map((item: any, index: any) => (
        <GameRow
          selectedId={gameInfo.edition_unified_id}
          key={index + item.edition_unified_id}
          gameInfo={item}
          searchValue={searchValue}
          isCollect={isCollect}
          handleCollect={handleCollect}
          searchText={searchText}
        />
      ))}
    </>
  );
};

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
  };
})(GameList);
